import { render, staticRenderFns } from "./PricesInfoSection.vue?vue&type=template&id=21fe25cc&scoped=true&"
import script from "./PricesInfoSection.vue?vue&type=script&lang=js&"
export * from "./PricesInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./PricesInfoSection.vue?vue&type=style&index=0&id=21fe25cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe25cc",
  null
  
)

export default component.exports